import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Trash2Icon } from 'lucide-react';
import InfoTransparent from '@/assets/icons/InfoTransparent';
import DialogMDR from '@/components/Jobs/DialogMDR';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

const SentMDR = ({ sentRequests, onRemove }) => {
  const [isRemoveDialog, setIsRemoveDialog] = useState();
  const [requestToRemove, setRequestToRemove] = useState();
  const statusCells = {
    Done: '✅ Levert',
    Pending: '⌛ Venter',
    Cancelled: '⛔ Avsluttet',
  };
  const handleRemoveConfirmation = () => {
    setIsRemoveDialog(false);
    onRemove(requestToRemove);
  };
  return (
    <div>
      <div className="grid grid-cols-12 border-b">
        <div className="text-muted-foreground font-medium text-sm col-span-5 sm:p-4 p-2">
          Selskap
        </div>
        <div className=" text-muted-foreground font-medium text-sm col-span-2 sm:py-4 py-2">
          Status
        </div>
      </div>
      {sentRequests.map((request) => (
        <div className="grid items-center justify-items-start grid-cols-12 border-b sm:p-4 p-2">
          <div className="flex items-center col-span-5 font-medium sm:text-sm text-[12px] pr-1">
            {request.organizationName}
          </div>
          <div className="flex items-center sm:col-span-2 col-span-3 border rounded-xl mr-1 py-0.5 px-2.5 text-center sm:text-xs text-[10px] font-semibold">
            {statusCells[request.status]}
          </div>
          <div className="flex items-center col-span-3 font-medium text-sm">
            <DialogMDR
              trigger={
                <Button
                  className="border sm:text-sm text-[12px] sm:py-2 sm:px-4 p-1 sm:gap-2 gap-0.5"
                  variant="ghost"
                  type="button"
                >
                  <InfoTransparent /> Detaljer
                </Button>
              }
              data={request}
              statusCell={statusCells[request.status]}
            />
          </div>
          <div className="flex w-full justify-center items-center sm:col-span-2 col-span-1">
            <Dialog
              open={isRemoveDialog}
              onOpenChange={(value) => setIsRemoveDialog(value)}
            >
              <DialogTrigger asChild>
                <Button
                  className="sm:max-w-10 w-full sm:py-2 sm:px-4 p-0 h-10"
                  type="button"
                  onClick={() => setRequestToRemove(request)}
                >
                  <Trash2Icon />
                </Button>
              </DialogTrigger>
              <DialogContent className="flex flex-col gap-2 sm:gap-4 items-start sm:max-w-[425px]">
                <DialogTitle className="text-lg font-semibold text-foreground">
                  Vil du slette forespørselen?
                </DialogTitle>
                <p className="sm:text-sm text-[12px] text-muted-foreground">
                  Dette kan ikke angres, og forespørselen blir fjernet hos
                  håndverkeren. Du kan sende en ny forespørsel senere hvis du
                  ombestemmer deg.
                </p>
                <div className="flex self-end gap-2">
                  <Button
                    className="border w-full sm:py-2 sm:px-4 p-1 h-10"
                    variant="ghost"
                    type="button"
                    onClick={() => setIsRemoveDialog(false)}
                  >
                    Avbryt
                  </Button>
                  <Button
                    className="w-full sm:py-2 sm:px-4 p-1 h-10"
                    type="button"
                    onClick={handleRemoveConfirmation}
                  >
                    Slett forespørsel
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SentMDR;
